import React from "react"
import { Grid, Typography } from "@material-ui/core"
import useDidMount from "@/hooks/useDidMount"
import AnalyticsService from "@/services/Analytics"

import { reportsTypeToTitle } from "@/protocols/reports"
import { externalLinks } from "@/utils/link"

import UtmsReportTable from "@/pages/Admin/Reports/UtmsReport/UtmsReportTable"
import ReportFeedbackAlert from "@/pages/Admin/Reports/components/ReportFeedbackAlert"
import useStyles from "@/pages/Admin/Reports/UtmsReport/styles"

const UtmsReport: React.FC = () => {
	const classes = useStyles()

	useDidMount(() => { AnalyticsService.capture("utm_report_opened") })

	return (
		<Grid
			container
			direction="column"
			spacing={6}
		>
			<Grid item>
				<Typography
					variant="h5"
					className={classes.titleText}
				>
					{reportsTypeToTitle["utms-report"]}
				</Typography>
			</Grid>
			<Grid item>
				<ReportFeedbackAlert
					linkToForms={externalLinks.utmsReportFeedbackForm}
					linkDescription="Para aprimorarmos nosso relatório de UTMs, convidamos você a preencher um rápido formulário e compartilhar seu feedback."
				/>
			</Grid>

			<Grid item>
				<UtmsReportTable/>
			</Grid>
		</Grid>
	)
}

export default UtmsReport
